import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import FinancialProductStateSelectionContainer from './FinancialProductStateSelectionContainer';
import { Grid } from '@mui/material';
import { Typography } from '@totalsoft/rocket-ui';

const Header = ({ canWrite, title }) => {
  const [t] = useTranslation();
  return (
    <Grid container wrap='nowrap'>
      <Grid item xs>
        <Typography noWrap variant='subtitle1' fontWeight='bold' sx={{ pr: 0.5 }}>
          {title ? `${t('FinancialProduct.Title')} - ${title}` : t('FinancialProduct.Title')}
        </Typography>
      </Grid>
      <Grid item mx={1}>
        <FinancialProductStateSelectionContainer canWrite={canWrite} />
      </Grid>
    </Grid>
  );
};

Header.propTypes = {
  canWrite: PropTypes.bool.isRequired,
  title: PropTypes.string
};

export default Header;
